import axios from 'axios';
import { DomainDesignAsset } from '../../design/models/DomainDesignAsset';
import { DomainDesignModel } from '../../design/models/DomainDesignModel';
import Config from '../config';
import AuthService from './AuthService';

class ThemeService {
  /** Retrieve the combined MUI and skin themes. */
  public async getThemeModel(): Promise<DomainDesignModel> {
    const { data } = await axios.get<DomainDesignModel>(
      `${Config.DESIGN_DS}/api/themes/${AuthService.Tenant}`
    );
    return data;
  }

  /**
   * Save the design. The PublicAPI requires admin permissions to save.
   * @param model Design theme to save.
   */
  public async saveTheme(model: DomainDesignAsset): Promise<DomainDesignModel> {
    const { data } = await axios.post<DomainDesignModel>(
      `${Config.DESIGN_DS}/api/themes`,
      model,
      {
        headers: {
          authorization: `Bearer ${AuthService.getAccessToken()}`,
          'content-type': 'application/json'
        }
      }
    );
    return data;
  }
}

export default new ThemeService();
